import i18n from "i18next";
import k from "src/i18n/keys";

import { useDispatch, useSelector } from "react-redux";
import { Portal } from "@chakra-ui/react";

import List from "./List";
import Current from "./Current";
import Loader from "./Loader";
import { NoDashboard } from "./styles";
import { Overlay, Container as StyledDashboard } from "src/styles/splitPane";
import Close from "src/containers/Close";
import { setDashboardAndRefreshCharts } from "src/actions/dashboard";
import { getCurrentDashboard, getIsDashboardLoading } from "src/reducers";

import type { AppState } from "src/types";
import { useEffect } from "react";

const Dashboard = (): React.ReactElement => {
  const dispatch = useDispatch();

  const isDashboardLoading = useSelector(({ app }: { app: AppState }) =>
    getIsDashboardLoading(app),
  );
  const id = useSelector(({ app }: { app: AppState }) =>
    getCurrentDashboard(app),
  );

  useEffect(() => {
    // Refresh charts every time the user navigates to Dashboard
    if (id) {
      dispatch(setDashboardAndRefreshCharts(id));
    }
  }, [id]);

  return (
    <Portal>
      <Close />
      <Overlay>
        <StyledDashboard>
          <List />

          {isDashboardLoading ? (
            <Loader id={isDashboardLoading} />
          ) : (
            <>
              {id ? (
                <Current />
              ) : (
                <NoDashboard>{i18n.t(k.NO_DASHBOARD_SELECTED)}</NoDashboard>
              )}
            </>
          )}
        </StyledDashboard>
      </Overlay>
    </Portal>
  );
};

export default Dashboard;
